@include host-component-properties;

:host {
  --paf-result-alert-background-color: var(--paf-global-post-error-background);
  --paf-result-alert-padding-block: 12;
  --paf-result-alert-padding-inline: 16;
  --paf-result-alert-font-size: 16;
  --paf-result-alert-gap: 16;
  --paf-result-alert-description-line-height: 24;
}

.result-alert {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: px-to-rem(var(--paf-result-alert-gap));
  background-color: var(--paf-result-alert-background-color);
  padding: px-to-rem(var(--paf-result-alert-padding-block)) px-to-rem(var(--paf-result-alert-padding-inline));

  .icon {
    flex-shrink: 0;
    flex-grow: 0;
  }

  .description {
    flex: 1;
    font-size: px-to-rem(var(--paf-result-alert-font-size));
    line-height: px-to-rem(var(--paf-result-alert-description-line-height));
  }
}
